/* eslint-disable */
declare global {
	interface Window {
		mixpanel: any
		type: string
		async: any
		src: any
	}
}

let _loaded = false
const MIXPANEL_CUSTOM_LIB_URL: any = undefined // Typescript requires this const to be declared and as we want to get the library from the Mixpanel general URL, we declare it on false

function init(clientId: string) {
	if (_loaded) {
		return
	}
	_loaded = true
	initScript(document, window.mixpanel || [])
	window.mixpanel.init(clientId)
}

function initScript(e: any, a: any) {
	if (!a.__SV) {
		var b = window
		try {
			var c,
				l,
				i,
				j = b.location,
				g = j.hash
			c = function (a: any, b: any) {
				// eslint-disable-next-line no-cond-assign
				return (l = a.match(RegExp(b + '=([^&]*)'))) ? l[1] : null
			}
			g &&
				c(g, 'state') &&
				((i = JSON.parse(decodeURIComponent(c(g, 'state')))),
				'mpeditor' === i.action &&
					(b.sessionStorage.setItem('_mpcehash', g),
					history.replaceState(i.desiredHash || '', e.title, j.pathname + j.search)))
		} catch (m) {}
		var k, h
		window.mixpanel = a
		a._i = []
		a.init = function (b: any, c: any, f: any) {
			function e(b: any, a: any) {
				var c = a.split('.')
				2 == c.length && ((b = b[c[0]]), (a = c[1]))
				b[a] = function () {
					b.push([a].concat(Array.prototype.slice.call(arguments, 0)))
				}
			}
			var d = a
			'undefined' !== typeof f ? (d = a[f] = []) : (f = 'mixpanel')
			d.people = d.people || []
			d.toString = function (b: any) {
				var a = 'mixpanel'
				'mixpanel' !== f && (a += '.' + f)
				b || (a += ' (stub)')
				return a
			}
			d.people.toString = function () {
				return d.toString(1) + '.people (stub)'
			}
			k =
				'disable time_event track track_pageview track_links track_forms register register_once alias unregister identify name_tag set_config reset people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user'.split(
					' '
				)
			for (h = 0; h < k.length; h++) e(d, k[h])
			a._i.push([b, c, f])
		}
		a.__SV = 1.2
		b = e.createElement('script')
		b.type = 'text/javascript'
		b.async = !0
		b.src =
			'undefined' !== typeof MIXPANEL_CUSTOM_LIB_URL
				? MIXPANEL_CUSTOM_LIB_URL
				: 'file:' === e.location.protocol && '//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js'.match(/^\/\//)
				? 'https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js'
				: '//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js'
		c = e.getElementsByTagName('script')[0]
		c.parentNode.insertBefore(b, c)
	}
}

function track(event: any, properties: any, needsCallback: any) {
	return new Promise<void>(function (resolve) {
		function dispatchSuccess() {
			resolve()
		}
		var _callback = needsCallback ? dispatchSuccess : null
		if (typeof window.mixpanel !== 'undefined') {
			window.mixpanel.track(event, properties, _callback)
		}
		if (!needsCallback) {
			resolve()
		} else {
			setTimeout(dispatchSuccess, 500)
		}
	})
}

function alias(presenterUid: any) {
	return new Promise<void>(function (resolve) {
		if (typeof window.mixpanel !== 'undefined') {
			window.mixpanel.alias(presenterUid)
		}
		resolve()
	})
}

function reset() {
	return new Promise<void>(function (resolve) {
		if (typeof window.mixpanel !== 'undefined') {
			window.mixpanel.reset()
		}
		resolve()
	})
}

function setPeopleProperties(props: any) {
	return new Promise<void>(function (resolve) {
		if (typeof window.mixpanel !== 'undefined') {
			window.mixpanel.people.set(props)
		}
		resolve()
	})
}

function getDistinctId() {
	return new Promise(function (resolve) {
		let distinctId = ''
		if (typeof window.mixpanel !== 'undefined') {
			distinctId = window.mixpanel.get_distinct_id()
		}
		resolve(distinctId)
	})
}

export default {
	init: init,
	alias: alias,
	reset: reset,
	setPeopleProperties: setPeopleProperties,
	track: track,
	getDistinctId: getDistinctId,
}
